module.exports = __webpack_public_path__ + "static/media/rocket-bg.80e060ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rocket-bg.jpg
// module id = 1368
// module chunks = 0